export var BuiltInEncodeNames;

!function(BuiltInEncodeNames) {
    BuiltInEncodeNames.enter = "enter", BuiltInEncodeNames.update = "update", BuiltInEncodeNames.exit = "exit", 
    BuiltInEncodeNames.group = "group", BuiltInEncodeNames.connectNulls = "connectNulls";
}(BuiltInEncodeNames || (BuiltInEncodeNames = {}));

export var DiffState;

!function(DiffState) {
    DiffState.enter = "enter", DiffState.update = "update", DiffState.exit = "exit", 
    DiffState.unChange = "unChange";
}(DiffState || (DiffState = {}));

export var GrammarMarkType;

!function(GrammarMarkType) {
    GrammarMarkType.arc = "arc", GrammarMarkType.arc3d = "arc3d", GrammarMarkType.area = "area", 
    GrammarMarkType.image = "image", GrammarMarkType.line = "line", GrammarMarkType.path = "path", 
    GrammarMarkType.rect = "rect", GrammarMarkType.rect3d = "rect3d", GrammarMarkType.rule = "rule", 
    GrammarMarkType.shape = "shape", GrammarMarkType.symbol = "symbol", GrammarMarkType.text = "text", 
    GrammarMarkType.richtext = "richtext", GrammarMarkType.polygon = "polygon", GrammarMarkType.pyramid3d = "pyramid3d", 
    GrammarMarkType.circle = "circle", GrammarMarkType.cell = "cell", GrammarMarkType.interval = "interval", 
    GrammarMarkType.group = "group", GrammarMarkType.glyph = "glyph", GrammarMarkType.component = "component", 
    GrammarMarkType.largeRects = "largeRects", GrammarMarkType.largeSymbols = "largeSymbols";
}(GrammarMarkType || (GrammarMarkType = {}));

export var ComponentEnum;

!function(ComponentEnum) {
    ComponentEnum.axis = "axis", ComponentEnum.grid = "grid", ComponentEnum.legend = "legend", 
    ComponentEnum.slider = "slider", ComponentEnum.label = "label", ComponentEnum.datazoom = "datazoom", 
    ComponentEnum.player = "player", ComponentEnum.title = "title", ComponentEnum.scrollbar = "scrollbar";
}(ComponentEnum || (ComponentEnum = {}));

export var DataFilterRank;

!function(DataFilterRank) {
    DataFilterRank[DataFilterRank.player = 1] = "player", DataFilterRank[DataFilterRank.rollUp = 2] = "rollUp", 
    DataFilterRank[DataFilterRank.drillDown = 3] = "drillDown", DataFilterRank[DataFilterRank.slider = 4] = "slider", 
    DataFilterRank[DataFilterRank.datazoom = 5] = "datazoom", DataFilterRank[DataFilterRank.legend = 6] = "legend", 
    DataFilterRank[DataFilterRank.scrollbar = 7] = "scrollbar", DataFilterRank[DataFilterRank.brush = 8] = "brush", 
    DataFilterRank[DataFilterRank.normal = 9] = "normal";
}(DataFilterRank || (DataFilterRank = {}));

export var AxisEnum;

!function(AxisEnum) {
    AxisEnum.lineAxis = "lineAxis", AxisEnum.circleAxis = "circleAxis";
}(AxisEnum || (AxisEnum = {}));

export var GridEnum;

!function(GridEnum) {
    GridEnum.lineAxisGrid = "lineAxisGrid", GridEnum.circleAxisGrid = "circleAxisGrid";
}(GridEnum || (GridEnum = {}));

export var LegendEnum;

!function(LegendEnum) {
    LegendEnum.discreteLegend = "discreteLegend", LegendEnum.colorLegend = "colorLegend", 
    LegendEnum.sizeLegend = "sizeLegend";
}(LegendEnum || (LegendEnum = {}));

export var CrosshairEnum;

!function(CrosshairEnum) {
    CrosshairEnum.lineCrosshair = "lineCrosshair", CrosshairEnum.rectCrosshair = "rectCrosshair", 
    CrosshairEnum.sectorCrosshair = "sectorCrosshair", CrosshairEnum.circleCrosshair = "circleCrosshair", 
    CrosshairEnum.polygonCrosshair = "polygonCrosshair", CrosshairEnum.ringCrosshair = "ringCrosshair";
}(CrosshairEnum || (CrosshairEnum = {}));

export var LabelEnum;

!function(LabelEnum) {
    LabelEnum.symbolLabel = "symbolLabel", LabelEnum.rectLabel = "rectLabel", LabelEnum.lineLabel = "lineLabel", 
    LabelEnum.dataLabel = "dataLabel";
}(LabelEnum || (LabelEnum = {}));

export var PlayerEnum;

!function(PlayerEnum) {
    PlayerEnum.continuousPlayer = "continuousPlayer", PlayerEnum.discretePlayer = "discretePlayer";
}(PlayerEnum || (PlayerEnum = {}));

export var LayoutState;

!function(LayoutState) {
    LayoutState.before = "before", LayoutState.layouting = "layouting", LayoutState.reevaluate = "reevaluate", 
    LayoutState.after = "after";
}(LayoutState || (LayoutState = {}));

export var HOOK_EVENT;

!function(HOOK_EVENT) {
    HOOK_EVENT.BEFORE_EVALUATE_DATA = "beforeEvaluateData", HOOK_EVENT.AFTER_EVALUATE_DATA = "afterEvaluateData", 
    HOOK_EVENT.BEFORE_EVALUATE_SCALE = "beforeEvaluateScale", HOOK_EVENT.AFTER_EVALUATE_SCALE = "afterEvaluateScale", 
    HOOK_EVENT.BEFORE_PARSE_VIEW = "beforeParseView", HOOK_EVENT.AFTER_PARSE_VIEW = "afterParseView", 
    HOOK_EVENT.BEFORE_TRANSFORM = "beforeTransform", HOOK_EVENT.AFTER_TRANSFORM = "afterTransform", 
    HOOK_EVENT.BEFORE_CREATE_VRENDER_STAGE = "beforeCreateVRenderStage", HOOK_EVENT.AFTER_CREATE_VRENDER_STAGE = "afterCreateVRenderStage", 
    HOOK_EVENT.BEFORE_CREATE_VRENDER_LAYER = "beforeCreateVRenderLayer", HOOK_EVENT.AFTER_CREATE_VRENDER_LAYER = "afterCreateVRenderLayer", 
    HOOK_EVENT.BEFORE_STAGE_RESIZE = "beforeStageResize", HOOK_EVENT.AFTER_STAGE_RESIZE = "afterStageResize", 
    HOOK_EVENT.BEFORE_VRENDER_DRAW = "beforeVRenderDraw", HOOK_EVENT.AFTER_VRENDER_DRAW = "afterVRenderDraw", 
    HOOK_EVENT.BEFORE_MARK_JOIN = "beforeMarkJoin", HOOK_EVENT.AFTER_MARK_JOIN = "afterMarkJoin", 
    HOOK_EVENT.BEFORE_MARK_UPDATE = "beforeMarkUpdate", HOOK_EVENT.AFTER_MARK_UPDATE = "afterMarkUpdate", 
    HOOK_EVENT.BEFORE_MARK_STATE = "beforeMarkState", HOOK_EVENT.AFTER_MARK_STATE = "afterMarkState", 
    HOOK_EVENT.BEFORE_MARK_ENCODE = "beforeMarkEncode", HOOK_EVENT.AFTER_MARK_ENCODE = "afterMarkEncode", 
    HOOK_EVENT.BEFORE_DO_LAYOUT = "beforeDoLayout", HOOK_EVENT.AFTER_DO_LAYOUT = "afterDoLayout", 
    HOOK_EVENT.BEFORE_MARK_LAYOUT_END = "beforeMarkLayoutEnd", HOOK_EVENT.AFTER_MARK_LAYOUT_END = "afterMarkLayoutEnd", 
    HOOK_EVENT.BEFORE_DO_RENDER = "beforeDoRender", HOOK_EVENT.AFTER_DO_RENDER = "afterDoRender", 
    HOOK_EVENT.BEFORE_MARK_RENDER_END = "beforeMarkRenderEnd", HOOK_EVENT.AFTER_MARK_RENDER_END = "afterMarkRenderEnd", 
    HOOK_EVENT.BEFORE_CREATE_VRENDER_MARK = "beforeCreateVRenderMark", HOOK_EVENT.AFTER_CREATE_VRENDER_MARK = "afterCreateVRenderMark", 
    HOOK_EVENT.BEFORE_ADD_VRENDER_MARK = "beforeAddVRenderMark", HOOK_EVENT.AFTER_ADD_VRENDER_MARK = "afterAddVRenderMark", 
    HOOK_EVENT.AFTER_VRENDER_NEXT_RENDER = "afterVRenderNextRender", HOOK_EVENT.BEFORE_ELEMENT_UPDATE_DATA = "beforeElementUpdateData", 
    HOOK_EVENT.AFTER_ELEMENT_UPDATE_DATA = "afterElementUpdateData", HOOK_EVENT.BEFORE_ELEMENT_STATE = "beforeElementState", 
    HOOK_EVENT.AFTER_ELEMENT_STATE = "afterElementState", HOOK_EVENT.BEFORE_ELEMENT_ENCODE = "beforeElementEncode", 
    HOOK_EVENT.AFTER_ELEMENT_ENCODE = "afterElementEncode", HOOK_EVENT.ANIMATION_START = "animationStart", 
    HOOK_EVENT.ANIMATION_END = "animationEnd", HOOK_EVENT.ELEMENT_ANIMATION_START = "elementAnimationStart", 
    HOOK_EVENT.ELEMENT_ANIMATION_END = "elementAnimationEnd", HOOK_EVENT.ALL_ANIMATION_START = "allAnimationStart", 
    HOOK_EVENT.ALL_ANIMATION_END = "allAnimationEnd";
}(HOOK_EVENT || (HOOK_EVENT = {}));

export var GrammarTypeEnum;

!function(GrammarTypeEnum) {
    GrammarTypeEnum.signal = "signal", GrammarTypeEnum.data = "data", GrammarTypeEnum.scale = "scale", 
    GrammarTypeEnum.coordinate = "coordinate", GrammarTypeEnum.mark = "mark";
}(GrammarTypeEnum || (GrammarTypeEnum = {}));

export var InteractionStateEnum;

!function(InteractionStateEnum) {
    InteractionStateEnum.active = "active", InteractionStateEnum.selected = "selected", 
    InteractionStateEnum.highlight = "highlight", InteractionStateEnum.blur = "blur";
}(InteractionStateEnum || (InteractionStateEnum = {}));
//# sourceMappingURL=enums.js.map